<template>
  <div>
    <edit-button @click.prevent="params.editProducerEvent(params.data)" :label="params.change_producer_label" />
    <span class="space-actions"></span>
    <edit-button @click.prevent="params.editEvent(params.data)" :label="params.edit_label" />
    <span class="space-actions"></span>
    <destroy-button v-if="!params.data.proc_button_destroy" :disabled_button="false"
      @destroyEvent="params.destroyEvent(params.data)" :label="params.destroy_label" :title="params.destroy_title"
      :message="params.destroy_message" :label_confirm="params.destroy_label_confirm" />
    <destroy-button-processing v-else :label="params.destroy_label" />
  </div>
</template>

<script>
export default {
  name: "TableActions"
};
</script>
